export default "__VITE_ASSET__BIqJEHLl__"